import profile from './profile.json';
import objective from './objective.json';
import work from './work.json';
import education from './education.json';
import awards from './awards.json';
import certifications from './certifications.json';
import languages from './languages.json';
import references from './references.json';
import extras from './extras.json';

export default {
  profile,
  objective,
  work,
  education,
  awards,
  certifications,
  languages,
  references,
  extras,
};
